import { Debug } from '@prisma/debug'

export { Debug }
export default Debug
